import styled, { css } from 'styled-components';

export const Button = styled.li<{
  active?: boolean;
  variant?: 'default' | 'booster';
}>(({ theme, active, variant }) => {
  const isBooster = variant === 'booster';

  return css`
    font-size: ${theme.fontSize.m};
    font-weight: ${theme.fontWeight.semiBold};
    color: ${active ? theme.colors.verdigrisDark : theme.colors.platinum};
    padding-bottom: ${theme.spacing.s};
    position: ${theme.positions.relative};
    white-space: nowrap;
    ${isBooster &&
    css`
      flex: 1;
      text-align: left;
    `}

    &::before {
      ${active || isBooster
        ? css`
            content: '';
            position: ${theme.positions.absolute};
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 2px;
            border-radius: ${theme.radius.m};
            background-color: ${active
              ? theme.colors.verdigrisDark
              : theme.colors.platinum};
          `
        : ''}
    }
  `;
});
